import React, { useEffect, useState } from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement, CategoryScale, LinearScale } from 'chart.js';

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale, LinearScale);

const API = window.location.hostname === 'localhost'
  ? 'http://localhost:5000/api'
  : 'https://demo.myssa.net/api';

const PALETTE = [
  '#659db8',
  '#38bdf8',
  '#8b7b64',
  '#0ea5e9',
  '#d4c9b8',
  '#64748b',
  '#f0ece2',
  '#1e293b',
];

const Camembert1 = () => {
  const [chartData, setChartData] = useState({ labels: [], datasets: [] });

  useEffect(() => {
    fetch(`${API}/camembert_1`)
      .then(res => res.json())
      .then(data => {
        const labels = data.map(d => d.client);
        const values = data.map(d => Number(d.nb_commandes));

        setChartData({
          labels,
          datasets: [
            {
              data: values,
              backgroundColor: PALETTE.slice(0, labels.length).map(c => c + 'cc'),
              borderColor: '#ffffff',
              borderWidth: 2,
              hoverOffset: 6,
            },
          ],
        });
      })
      .catch(err => console.error('Erreur fetch camembert1:', err));
  }, []);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: true,
        text: 'CMDES / CLIENT',
        color: '#04202d',
        font: { family: "'IBM Plex Mono', monospace", size: 20, weight: '500' },
        padding: { bottom: 16 },
      },
      tooltip: {
        backgroundColor: '#ffffff',
        borderColor: '#f0ece2',
        borderWidth: 1,
        titleColor: '#04202d',
        bodyColor: '#8b7b64',
        titleFont: { family: "'IBM Plex Mono', monospace", size: 20 },
        bodyFont: { family: "'IBM Plex Sans', sans-serif", size: 20 },
        padding: 10,
      },
      legend: {
        position: 'bottom',
        labels: {
          color: '#8b7b64',
          font: { family: "'IBM Plex Sans', sans-serif", size: 11 },
          boxWidth: 12,
          boxHeight: 12,
          padding: 14,
        }
      }
    },
  };

  return (
    <div style={{
      background: '#ffffff',
      border: '1px solid #f0ece2',
      borderRadius: '14px',
      padding: '20px 24px',
      boxShadow: '0 2px 12px rgba(110, 212, 88, 0.06)',
      position: 'relative',
      overflow: 'hidden',
      width: '400px',
      height: '440px',
      boxSizing: 'border-box',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <div style={{
        position: 'absolute',
        top: 0, left: 0, right: 0,
        height: '3px',
        borderRadius: '14px 14px 0 0',
      }} />
      <Pie data={chartData} options={options} width={800} height={360} />
    </div>
  );
};

export default Camembert1;